module.exports = __webpack_public_path__ + "img/erp-logos_0031_jcurve.a872d47a.jpg";